import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import 'bootstrap/dist/css/bootstrap.min.css';

function FicheProtocoles() {
  const [activeTab, setActiveTab] = useState('simple');
  const [formData, setFormData] = useState({
    simple: {
      nomProjet: '',
      responsable: '',
      objectif: '',
      lieu: '',
      dateHeure: '',
      organisation: '',
      budget: '',
      motif: ''
    },
    avance: {
      encadrantPrincipal: '',
      intervenants: '',
      publicCible: '',
      capaciteLieu: '',
      dureeEvenement: '',
      equipements: '',
      planSecours: '',
      budgetDetaille: '',
      indicateursSucces: ''
    }
  });

  const handleTabChange = (tab) => setActiveTab(tab);

  const handleInputChange = (e, mode) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [mode]: { ...prevData[mode], [name]: value }
    }));
  };
  
  const formatDateHeure = (dateHeure) => {
    if (!dateHeure) return '';
    
    const date = new Date(dateHeure);
    const options = {
      weekday: 'long', // Nom du jour de la semaine
      year: 'numeric', // Année complète
      month: 'long', // Nom complet du mois
      day: 'numeric', // Jour du mois
      hour: '2-digit', // Heures sur deux chiffres
      minute: '2-digit', // Minutes sur deux chiffres
    };
    
    return date.toLocaleDateString('fr-FR', options); // Format en français
  };
  
  // Fonction pour générer le PDF
  const generatePDF = () => {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: 'a4',
      lineHeight: 1.6,
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;
    const contentWidth = pageWidth - margin * 2;
    let y = 60; // Position de départ du contenu

    const lineHeight = 14;
    const titleFontSize = 18;
    const contentFontSize = 12;

    // Fonction pour ajouter un titre centré
    const addTitle = (title) => {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(titleFontSize);
      doc.text(title, pageWidth / 2, y, { align: 'center' });
      y += 30; // Ajouter un espace après le titre
    };

    // Fonction pour ajouter du contenu
    const addContent = (label, text) => {
      if (text) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(contentFontSize);
        doc.text(`${label}:`, margin, y);
        y += lineHeight;

        doc.setFont('helvetica', 'normal');
        const lines = doc.splitTextToSize(text, contentWidth);
        doc.text(lines, margin, y);
        y += lines.length * lineHeight + 10; // Ajouter de l'espace après le contenu
      }
    };

    // Ajouter l'en-tête
    addTitle('Fiche Projet');

    // Mode Simple
    addTitle(formData.simple.nomProjet);
    addContent('Organisateur', formData.simple.responsable);
    addContent('Objectif', formData.simple.objectif);
    addContent('Lieu', formData.simple.lieu);
    addContent('Date et heure', formatDateHeure(formData.simple.dateHeure));
    addContent('Organisation', formData.simple.organisation);
    addContent('Budget estimé', formData.simple.budget);
    addContent('Motif', formData.simple.motif);

    // Vérifier si l'on atteint la fin de la page avant d'ajouter le mode avancé
    if (y + 100 > doc.internal.pageSize.height - margin) {
      doc.addPage();
      y = margin;
    }

    // Mode Avancé
    addTitle('Détails du Projet');
    addContent('Encadrant principal', formData.avance.encadrantPrincipal);
    addContent('Intervenants', formData.avance.intervenants);
    addContent('Public cible', formData.avance.publicCible);
    addContent('Capacité du lieu', formData.avance.capaciteLieu);
    addContent('Durée de l’événement', formData.avance.dureeEvenement);
    addContent('Équipements nécessaires', formData.avance.equipements);
    addContent('Plan de secours', formData.avance.planSecours);
    addContent('Budget détaillé', formData.avance.budgetDetaille);
    addContent('Indicateurs de succès', formData.avance.indicateursSucces);

    // Sauvegarder le PDF
    doc.save('fiche_projet_complete.pdf');
  };

  return (
    <div className="container my-5">
      <h2 className="text-center">Fiche Protocole de Projet</h2>

      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === 'simple' ? 'active' : ''}`}
            onClick={() => handleTabChange('simple')}
            href="#!"
          >
            Mode Simple
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === 'avance' ? 'active' : ''}`}
            onClick={() => handleTabChange('avance')}
            href="#!"
          >
            Mode Avancé
          </a>
        </li>
      </ul>

      {activeTab === 'simple' && (
        <div>
          <h3>Mode Simple</h3>
          <form>
            <div className="mb-3">
              <label>Nom du projet</label>
              <input
                type="text"
                className="form-control"
                name="nomProjet"
                value={formData.simple.nomProjet}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
            <div className="mb-3">
              <label>Organisateur</label>
              <input
                type="text"
                className="form-control"
                name="responsable"
                value={formData.simple.responsable}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
            <div className="mb-3">
              <label>Objectif</label>
              <input
                type="text"
                className="form-control"
                name="objectif"
                value={formData.simple.objectif}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
            <div className="mb-3">
              <label>Lieu</label>
              <input
                type="text"
                className="form-control"
                name="lieu"
                value={formData.simple.lieu}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
            <div className="mb-3">
              <label>Date et heure</label>
              <input
                type="datetime-local"
                className="form-control"
                name="dateHeure"
                value={formData.simple.dateHeure}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
            <div className="mb-3">
              <label>Organisation</label>
              <input
                type="text"
                className="form-control"
                name="organisation"
                value={formData.simple.organisation}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
            <div className="mb-3">
              <label>Budget estimé</label>
              <input
                type="text"
                className="form-control"
                name="budget"
                value={formData.simple.budget}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
            <div className="mb-3">
              <label>Motif</label>
              <input
                type="text"
                className="form-control"
                name="motif"
                value={formData.simple.motif}
                onChange={(e) => handleInputChange(e, 'simple')}
              />
            </div>
          </form>
        </div>
      )}

      {activeTab === 'avance' && (
        <div>
          <h3>Mode Avancé</h3>
          <form>
            <div className="mb-3">
              <label>Encadrant principal</label>
              <input
                type="text"
                className="form-control"
                name="encadrantPrincipal"
                value={formData.avance.encadrantPrincipal}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Intervenants</label>
              <input
                type="text"
                className="form-control"
                name="intervenants"
                value={formData.avance.intervenants}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Public cible</label>
              <input
                type="text"
                className="form-control"
                name="publicCible"
                value={formData.avance.publicCible}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Capacité du lieu</label>
              <input
                type="text"
                className="form-control"
                name="capaciteLieu"
                value={formData.avance.capaciteLieu}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Durée de l’événement</label>
              <input
                type="text"
                className="form-control"
                name="dureeEvenement"
                value={formData.avance.dureeEvenement}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Équipements nécessaires</label>
              <input
                type="text"
                className="form-control"
                name="equipements"
                value={formData.avance.equipements}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Plan de secours</label>
              <input
                type="text"
                className="form-control"
                name="planSecours"
                value={formData.avance.planSecours}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Budget détaillé</label>
              <input
                type="text"
                className="form-control"
                name="budgetDetaille"
                value={formData.avance.budgetDetaille}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
            <div className="mb-3">
              <label>Indicateurs de succès</label>
              <input
                type="text"
                className="form-control"
                name="indicateursSucces"
                value={formData.avance.indicateursSucces}
                onChange={(e) => handleInputChange(e, 'avance')}
              />
            </div>
          </form>
        </div>
      )}

      <button className="btn btn-primary mt-4" onClick={generatePDF}>
        Télécharger le PDF
      </button>
    </div>
  );
}

export default FicheProtocoles;
